import React, { useEffect } from 'react';

const ExternalRedirect: React.FC = () => {
    useEffect(() => {
        window.location.href = process.env.FLOW_AUTH_URL || 'https://flow.rupeezy.in'
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        }}>
            <p>Redirecting to Rupeezy...</p>
        </div>
    );
};

export default ExternalRedirect;